import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, allowedRoles, ...rest }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  return (
    <Route
      {...rest}
      render={(props) => (allowedRoles.includes(user.userType) ? (
        <Component {...props} />
      ) : (
        <Redirect to="/dashboard" />
      ))}
    />
  );
};
export default PrivateRoute;
